import Component from '../abstracts/Component';
import { trapFocusOnModal, removeTrapFocusOnModal } from '../utils/TrapFocus';

export default class MiniWishlistComponent extends Component {

  get SELECTORS() {
    return {
      miniwishlistBtn: '[data-miniwishlist-button]',
      miniwishlistAccessibiltyBtn: '[data-miniwishlist-accessibility-button]',
      miniwishlistContent: '[data-miniwishlist-content]',
      miniwishlistContentNotify: '[data-miniwishlistnotification-content]',
      miniwishlistCount: '[data-miniwishlist-qty]',
      miniwishlistIcon: '[data-mini-wishlist-icon]',
      isLogged: '[data-miniwishlist-is-logged]',
      removeItemBtn: '[data-js-remove-item]',
      page: '#page-wrapper'
    };
  }

  constructor(htmlEl) {
    super(htmlEl);
  }

  readDOM() {
    return {
      miniwishlistBtn: this.$component.querySelector(this.SELECTORS.miniwishlistBtn),
      miniwishlistAccessibiltyBtn: this.$component.querySelector(this.SELECTORS.miniwishlistAccessibiltyBtn),
      miniwishlistContent: this.$component.querySelector(this.SELECTORS.miniwishlistContent),
      miniwishlistCount: this.$component.querySelector(this.SELECTORS.miniwishlistCount),
      miniwishlistIcon: this.$component.querySelector(this.SELECTORS.miniwishlistIcon),
      isLogged: this.$component.querySelector(this.SELECTORS.isLogged),
      miniwishlistContentNotify: this.$component.querySelector(this.SELECTORS.miniwishlistContentNotify),
      removeItemBtns: this.$component.querySelectorAll(this.SELECTORS.removeItemBtn),
      page: document.querySelector(this.SELECTORS.page)
    }
  }

  /**
   * Update the mini wishlist content and update the wishlist counter.
   * If there are more than 2 items in the wishlist, open the wishlist reminder.
   */
  async updateMiniwishlist() {
    const url = this.dom.miniwishlistBtn.dataset.urlMiniWishlist;
    await fetch(url)
    .then(response => {
      return response.text();
    })
    .then(text => {
      const htmlResponse = new DOMParser().parseFromString(text, 'text/html');
      this.dom.miniwishlistContent.innerHTML = htmlResponse.querySelector(this.SELECTORS.miniwishlistContent).innerHTML;
      this.dom = this.readDOM();
    })
    .catch(error => console.error(error));
  }

/**
 * Opens a notification on wishlist add.
 * If the user is not logged in and the wishlist contains more than 2 items,
 * a wishlist reminder is triggered.
 */
  openQuickWishlistNotification(wishlistCount) {
    const url = this.dom.miniwishlistBtn.dataset.urlQuickWishlist;
    fetch(url)
    .then(response => {
      return response.text();
    })
    .then(text => {
      const htmlResponse = new DOMParser().parseFromString(text, 'text/html');
      this.dom.page.classList.add('--overlay');
      this.dom.miniwishlistContentNotify.innerHTML = htmlResponse.querySelector(this.SELECTORS.miniwishlistContent).innerHTML;
      this.dom.miniwishlistContentNotify.classList.add("--open");
      this.dom.miniwishlistContent.classList.add("hidden");
      trapFocusOnModal(this.$component);
      const timeout = setTimeout(() => {
        if (!this.dom.miniwishlistContentNotify.classList.contains('hover')) {
          this.dom.page.classList.remove('--overlay');
          this.dom.miniwishlistContentNotify.classList.remove("--open");
          this.dom.miniwishlistContent.classList.remove("hidden");
          this.dom.miniwishlistContentNotify.innerHTML = '';
          if(this.dom.isLogged.dataset.miniwishlistIsLogged == "false" && wishlistCount > 2){
            this.openWishlistReminder();
          }
        }
      }, 3000);

      let ctx = this.dom;
      // Hides the notification if the user clicks anywhere on the page
      document.addEventListener('click', function hideNotification(event) {
        if (!ctx.miniwishlistContentNotify.contains(event.target)) {
          clearTimeout(timeout);
          ctx.page.classList.remove('--overlay');
          ctx.miniwishlistContentNotify.classList.remove('--open');
          document.removeEventListener('click', hideNotification);
        }
      });
      // Keeps notification visible if the mouse is over
      ctx.miniwishlistContentNotify.addEventListener('mouseenter', () => {
        ctx.miniwishlistContentNotify.classList.add('hover');
      });
      // Hides the notification if it is no longer hover and 3 seconds have passed
      ctx.miniwishlistContentNotify.addEventListener('mouseleave', () => {
        ctx.miniwishlistContentNotify.classList.remove('hover');
        setTimeout(() => {
          ctx.page.classList.remove('--overlay');
          ctx.miniwishlistContentNotify.classList.remove('--open');
        }, 3000);
      });

    })
    .catch((error) => {
      this.dom.page.classList.remove('--overlay');
      console.error(error);
    });
  }

  /**
   * Wishlist reminder popup. The reminder is only shown if the user is not logged in
   * and the wishlist has more than 2 items.
   */
  openWishlistReminder() {
    const url = this.dom.miniwishlistBtn.dataset.urlQuickWishlistReminder;
    fetch(url)
    .then(response => {
      return response.text();
    })
    .then(text => {
      setTimeout(() => {
        const htmlResponse = new DOMParser().parseFromString(text, 'text/html');
        this.dom.page.classList.add('--overlay');
        this.dom.miniwishlistContentNotify.innerHTML = htmlResponse.querySelector(this.SELECTORS.miniwishlistContent).innerHTML;
        this.dom.miniwishlistContentNotify.classList.add("--open");
        this.dom.miniwishlistContent.classList.add("hidden");
        const timeout = setTimeout(() => {
          if (!this.dom.miniwishlistContentNotify.classList.contains('hover')) {
            this.dom.page.classList.remove('--overlay');
            this.dom.miniwishlistContentNotify.classList.remove("--open");
            this.dom.miniwishlistContentNotify.innerHTML = '';
            this.updateMiniwishlist();
          }
        }, 3000);

        let ctx = this.dom;
        // Hides the notification if the user clicks anywhere on the page
        document.addEventListener('click', function hideNotification(event) {
          if (!ctx.miniwishlistContentNotify.contains(event.target)) {
            clearTimeout(timeout);
            ctx.page.classList.remove('--overlay');
            ctx.miniwishlistContentNotify.classList.remove('--open');
            document.removeEventListener('click', hideNotification);
          }
        });
        // Keeps notification visible if the mouse is over
        ctx.miniwishlistContentNotify.addEventListener('mouseenter', () => {
          ctx.miniwishlistContentNotify.classList.add('hover');
        });
        // Hides the notification if it is no longer hover and 3 seconds have passed
        ctx.miniwishlistContentNotify.addEventListener('mouseleave', () => {
          ctx.miniwishlistContentNotify.classList.remove('hover');
          setTimeout(() => {
            if (!ctx.miniwishlistContentNotify.classList.contains('hover')) {
              ctx.page.classList.remove('--overlay');
              ctx.miniwishlistContentNotify.classList.remove('--open');
            }
          }, 3000);
        });

      }, 10000);
    })
    .catch(error => console.error(error));
  }

  handleAccessibilityButton() {
    this.dom.miniwishlistAccessibiltyBtn.addEventListener("click", () => {
      this.dom.miniwishlistAccessibiltyBtn.classList.toggle("--opened");
      this.$component.classList.toggle("--open");
      if(this.dom.miniwishlistAccessibiltyBtn.classList.contains("--opened")) {
        this.dom.miniwishlistAccessibiltyBtn.setAttribute("aira-expanded","true");
        this.trapFocusHandler = trapFocusOnModal(this.dom.miniwishlistContent);
        this.dom.miniwishlistContent.addEventListener('keydown', event => {
          if(event.key === "Escape") {
            this.dom.miniwishlistAccessibiltyBtn.setAttribute("aira-expanded","false");
            this.dom.miniwishlistAccessibiltyBtn.classList.remove("--opened");
            this.$component.classList.remove("--open");
            removeTrapFocusOnModal(this.$component, this.trapFocusHandler);
            this.trapFocusHandler = null;
            this.dom.miniwishlistAccessibiltyBtn.focus();
          }
        });
      } else {
        this.dom.miniwishlistAccessibiltyBtn.setAttribute("aira-expanded","false");
        this.dom.miniwishlistAccessibiltyBtn.classList.remove("--opened");
        this.$component.classList.remove("--open");
        removeTrapFocusOnModal(this.$component, this.trapFocusHandler);
        this.trapFocusHandler = null;
      }
    });
  }

  bindEvents() {
    // updates mini wishlist content on wishlist add and updates counter
    this.$on(this.$customEvents.PRODUCT_EVENTS.addedtowish, ({event, payload}) => {
      const newWishlistQty = parseInt(this.dom.miniwishlistCount.dataset.miniwishlistQty, 10) + 1;
      this.dom.miniwishlistCount.dataset.miniwishlistQty = newWishlistQty;
      this.updateMiniwishlist();
      this.openQuickWishlistNotification(newWishlistQty);
    });

    // updates mini wishlist content on wishlist remove and updates counter
    this.$on(this.$customEvents.PRODUCT_EVENTS.removedfromwish, ({event, payload}) => {
      const newWishlistQty = parseInt(this.dom.miniwishlistCount.dataset.miniwishlistQty, 10) - 1;
      this.dom.miniwishlistCount.dataset.miniwishlistQty = newWishlistQty;
      this.updateMiniwishlist();
    });

    // communication popup timer logic //
    if(window.innerWidth >= 1024) {
      this.$component.addEventListener("mouseover", event => {
        this.$emit(this.$customEvents.POPUP_EVENTS.pauseTimer);
      });
      this.$component.addEventListener("mouseout", event => {
        if(document.body.dataset.jsLayerIsOpen == "false") {
          this.$emit(this.$customEvents.POPUP_EVENTS.resumeTimer);
        }
      });
    }

    this.handleAccessibilityButton();
  }

  render() {
    this.log('Rendering...');
    this.dom = this.readDOM();
    // on page load retrieve the mini wishlist content
    this.updateMiniwishlist().then( res => {
      this.bindEvents();
    });
  }

}
